import * as actionTypes from './actionTypes';

export const initPostFormStart = (PostId, isDraft, isGift, redirectPath, UserId, isManagedUser) => {
  return {
    type: actionTypes.INIT_POST_FORM_START,
    PostId,
    isDraft,
    isGift,
    redirectPath,
    UserId,
    isManagedUser,
  };
};

export const initPostForm = (PostId, isDraft, isGift, redirectPath) => {
  return {
    type: actionTypes.INIT_POST_FORM,
    PostId,
    isDraft,
    isGift,
    redirectPath,
  };
};

export const uploadPostImage = (Image, Type, SizeTo, CommentType) => {
  return {
    type: actionTypes.UPLOAD_POST_IMAGE,
    Image,
    Type,
    SizeTo,
    CommentType,
  };
};

export const clearCommentImages = (CommentType) => {
  return {
    type: actionTypes.CLEAR_COMMENT_IMAGES,
    CommentType,
  };
};

export const uploadPostImageStart = () => {
  return {
    type: actionTypes.UPLOAD_POST_IMAGE_START,
  };
};

export const uploadPostImageFailed = (error) => {
  return {
    type: actionTypes.UPLOAD_POST_IMAGE_FAILED,
    error,
  };
};

export const uploadPostImageSuccess = (postImage, Type, CommentType) => {
  return {
    type: actionTypes.UPLOAD_POST_IMAGE_SUCCESS,
    postImage,
    Type,
    CommentType,
  };
};

export const reorderPostImages = (postImages) => {
  return {
    type: actionTypes.REORDER_POST_IMAGES,
    postImages,
  };
};

export const addPost = (
  UserId,
  isManagedUser,
  LogIds,
  Name,
  ContentType,
  DateStart,
  DateEnd,
  TimeStart,
  TimeEnd,
  Desc,
  AddFileIds,
  SendToUserId,
  WhatTags,
  WhoTags,
  LocationTags,
  Ongoing,
  Location,
  Location2,
  LocIcon,
  LocFav,
  FavId,
  MapType,
  GeoLocation,
  Center,
  Pitch,
  Heading,
  Zoom,
  isDraft,
  MessageToUser,
  SaveCopyForSelf,
) => {
  return {
    type: actionTypes.ADD_POST,
    UserId,
    isManagedUser,
    LogIds,
    Name,
    ContentType,
    DateStart,
    DateEnd,
    TimeStart,
    TimeEnd,
    Desc,
    AddFileIds,
    SendToUserId,
    WhatTags,
    WhoTags,
    LocationTags,
    Ongoing,
    Location,
    Location2,
    LocIcon,
    LocFav,
    FavId,
    MapType,
    GeoLocation,
    Center,
    Pitch,
    Heading,
    Zoom,
    PostType: isDraft === true ? 'Draft' : 'Post',
    MessageToUser,
    SaveCopyForSelf,
  };
};

export const addPostStart = () => {
  return {
    type: actionTypes.ADD_POST_START,
  };
};

export const addPostSuccess = (PostId, isDraft, isGift) => {
  return {
    type: actionTypes.ADD_POST_SUCCESS,
    PostId,
    isDraft,
    isGift,
  };
};

export const addPostFailed = (error) => {
  return {
    type: actionTypes.ADD_POST_FAILED,
    error,
  };
};

export const removePostImage = (index, imageId, Type, CommentType) => {
  return {
    type: actionTypes.REMOVE_POST_IMAGE,
    index,
    imageId,
    Type,
    CommentType,
  };
};

export const fetchPost = (PostId, LogId, RoomId, isDraft, UserId, isManagedUser) => {
  return {
    type: actionTypes.FETCH_POST,
    PostId,
    LogId,
    RoomId,
    isDraft,
    UserId,
    isManagedUser,
  };
};

export const fetchPostStart = () => {
  return {
    type: actionTypes.FETCH_POST_START,
  };
};

export const fetchPostSuccess = (Post, Rooms) => {
  return {
    type: actionTypes.FETCH_POST_SUCCESS,
    Post,
    Rooms,
  };
};

export const fetchPostFailed = (error) => {
  return {
    type: actionTypes.FETCH_POST_FAILED,
    error,
  };
};

export const setPreviewPost = (Post) => {
  return {
    type: actionTypes.SET_PREVIEW_POST,
    Post,
  };
};

export const returnToPostForm = (isGift) => {
  return {
    type: actionTypes.RETURN_TO_GIFT_POST_FORM,
    isGift,
  };
};

export const deletePost = (postId, isManagedUser, UserId) => {
  return {
    type: actionTypes.DELETE_POST,
    postId,
    isManagedUser,
    UserId,
  };
};

export const deletePostStart = () => {
  return {
    type: actionTypes.DELETE_POST_START,
  };
};

export const deletePostSuccess = () => {
  return {
    type: actionTypes.DELETE_POST_SUCCESS,
  };
};

export const deletePostFailed = (error) => {
  return {
    type: actionTypes.DELETE_POST_FAILED,
    error,
  };
};

export const duplicatePost = (PostId, isDraft, copyNumber) => {
  return {
    type: actionTypes.DUPLICATE_POST,
    PostId,
    isDraft,
    copyNumber,
  };
};

export const duplicatePostStart = () => {
  return {
    type: actionTypes.DUPLICATE_POST_START,
  };
};

export const duplicatePostSuccess = () => {
  return {
    type: actionTypes.DUPLICATE_POST_SUCCESS,
  };
};

export const duplicatePostFailed = (error) => {
  return {
    type: actionTypes.DUPLICATE_POST_FAILED,
    error,
  };
};

export const editPost = (
  PostId,
  LogIds,
  Name,
  Type,
  DateStart,
  DateEnd,
  TimeStart,
  TimeEnd,
  Desc,
  AddFileIds,
  Suggested,
  WhatTags,
  WhoTags,
  LocationTags,
  RemovedImageIds,
  Ongoing,
  Location,
  Location2,
  LocIcon,
  LocFav,
  FavId,
  MapType,
  GeoLocation,
  Center,
  Pitch,
  Heading,
  Zoom,
  isDraft,
  CopyCommentFileIds,
  isManagedUser,
  UserId,
) => {
  return {
    type: actionTypes.EDIT_POST,
    EntryId: PostId,
    LogIds,
    Name,
    Type,
    DateStart,
    DateEnd,
    TimeStart,
    TimeEnd,
    Desc,
    Suggested,
    isManagedUser,
    UserId,
    WhatTags,
    WhoTags,
    LocationTags,
    AddFileIds,
    DeleteFileIds: RemovedImageIds,
    Ongoing,
    Location,
    Location2,
    LocIcon,
    LocFav,
    FavId,
    MapType,
    GeoLocation,
    Center,
    Pitch,
    Heading,
    Zoom,
    PostType: isDraft === true ? 'Draft' : 'Post',
    CopyCommentFileIds,
  };
};

export const editPostStart = () => {
  return {
    type: actionTypes.EDIT_POST_START,
  };
};

export const editPostSuccess = () => {
  return {
    type: actionTypes.EDIT_POST_SUCCESS,
  };
};

export const editPostFailed = (error) => {
  return {
    type: actionTypes.EDIT_POST_FAILED,
    error,
  };
};

export const addCommentImageToPost = (PostId, CommentImageId) => {
  return {
    type: actionTypes.ADD_COMMENT_IMAGE_TO_POST,
    PostId,
    CommentImageId,
  };
};

export const addCommentImageToPostStart = () => {
  return {
    type: actionTypes.ADD_COMMENT_IMAGE_TO_POST_START,
  };
};

export const addCommentImageToPostSuccess = () => {
  return {
    type: actionTypes.ADD_COMMENT_IMAGE_TO_POST_SUCCESS,
  };
};

export const addCommentImageToPostFailed = (error) => {
  return {
    type: actionTypes.ADD_COMMENT_IMAGE_TO_POST_FAILED,
    error,
  };
};

export const closePostForm = () => {
  return {
    type: actionTypes.CLOSE_POST_FORM,
  };
};

export const submitPostComment = (
  PostId,
  LogId,
  UserId,
  isManagedUser,
  Comment,
  CommentImageId,
  ParentCommentId,
  RoomId,
  WhoTags,
  WhatTags,
  LocationTags,
) => {
  return {
    type: actionTypes.SUBMIT_POST_COMMENT,
    PostId,
    LogId,
    UserId,
    isManagedUser,
    Comment,
    CommentImageId,
    ParentCommentId,
    RoomId,
    WhoTags,
    WhatTags,
    LocationTags,
  };
};

export const submitPostCommentStart = () => {
  return {
    type: actionTypes.SUBMIT_POST_COMMENT_START,
  };
};

export const submitPostCommentSuccess = () => {
  return {
    type: actionTypes.SUBMIT_POST_COMMENT_SUCCESS,
  };
};

export const submitPostCommentFailed = (error) => {
  return {
    type: actionTypes.SUBMIT_POST_COMMENT_FAILED,
    error,
  };
};

export const entryCommentUpdate = (CommentId, Comment, Delete, isManagedUser, UserId, WhoTags, WhatTags, LocationTags) => {
  return {
    type: actionTypes.ENTRY_COMMENT_UPDATE,
    CommentId,
    Comment,
    Delete,
    isManagedUser,
    UserId,
    WhoTags,
    WhatTags,
    LocationTags,
  };
};

export const entryCommentUpdateStart = () => {
  return {
    type: actionTypes.ENTRY_COMMENT_UPDATE_START,
  };
};

export const entryCommentUpdateSuccess = () => {
  return {
    type: actionTypes.ENTRY_COMMENT_UPDATE_SUCCESS,
  };
};

export const entryCommentUpdateFailed = (error) => {
  return {
    type: actionTypes.ENTRY_COMMENT_UPDATE_FAILED,
    error,
  };
};

export const togglePostDetailNavOptions = () => {
  return {
    type: actionTypes.TOGGLE_POST_DETAIL_NAV_OPTIONS,
  };
};
